import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { EARN_DIAMONDS_HINT_KEYS_LIST } from '@lootboy/lib/constants';
import { userSelector } from '@lootboy/lib/selectors';

import BalancePopup, { THint } from '~/components/molecules/BalancePopup';
import NewTabOpener from '~/components/NewTabOpener';

import { useOfferWallHook } from '~/redux/hooks/useOfferWallHook';
import {
  DAILY_PATH,
  DIAMOND_DUNGEON,
  EXPLORATION_QUEST_PATH,
} from '~/routes/paths';

import diamondL from '~/assets/images/currencies/Diamond Front Left.png';
import diamondC from '~/assets/images/currencies/Diamond Front.png';
import diamondsS from '~/assets/images/currencies/Diamond S Solid.png';
import diamondsXS from '~/assets/images/currencies/Diamond XS Solid.png';

const hintsBase = {
  [EARN_DIAMONDS_HINT_KEYS_LIST.BOOST]: {
    img: diamondC,
    name: 'boost',
    to: DAILY_PATH,
  },
  [EARN_DIAMONDS_HINT_KEYS_LIST.EXPLORATION_QUESTS]: {
    img: diamondL,
    name: 'exploration',
    to: EXPLORATION_QUEST_PATH,
  },
  [EARN_DIAMONDS_HINT_KEYS_LIST.WEB_DIAMOND_DUNGEON]: {
    img: diamondsXS,
    offerWallName: 'diamond_dungeon',
    to: DIAMOND_DUNGEON,
    highlight: true,
  },
};

const propertyCreator = ({
  pathname,
  href,
}: {
  pathname?: string;
  href?: string;
}) =>
  pathname
    ? { to: pathname }
    : {
        // @ts-ignore dunno what to do
        component: (props) => (
          <NewTabOpener
            {...props}
            href={href}
          />
        ),
      };

export default function EarnDiamondsPopup(): JSX.Element {
  const { lootgemBalance } = useSelector(userSelector);
  const surveyQuests = useOfferWallHook('surveyQuests');
  const diamondDream = useOfferWallHook('diamondDream');
  const hints = useMemo(() => {
    const hintsWithOfferwalls: {
      [key: keyof typeof EARN_DIAMONDS_HINT_KEYS_LIST]: THint;
    } = { ...hintsBase };
    if (surveyQuests) {
      hintsWithOfferwalls[EARN_DIAMONDS_HINT_KEYS_LIST.WEB_SURVEY_QUESTS] = {
        img: diamondsXS,
        offerWallName: 'survey_quests',
        ...propertyCreator(surveyQuests),
      };
    }
    if (diamondDream) {
      hintsWithOfferwalls[EARN_DIAMONDS_HINT_KEYS_LIST.WEB_DIAMOND_DREAM] = {
        img: diamondsXS,
        offerWallName: 'diamond_dream',
        ...propertyCreator(diamondDream),
      };
    }
    return hintsWithOfferwalls;
  }, [diamondDream, surveyQuests]);

  return (
    <BalancePopup
      coins={lootgemBalance}
      src={diamondsS}
      translation="EarnDiamondsView"
      hints={hints}
      configKey="diamondHints"
    />
  );
}
